export default "__VITE_ASSET__zGTg3pWL__"